export const useI18n = (intl) => {
  const $fm = (id = '1', defaultMessage = '', value = {}) => {
    return intl?.formatMessage({ id, defaultMessage }, value) || defaultMessage;
  };
  return {
    $fm,
  };
};
